import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const LoadingToRedirect = () => {
  const [count, setCount] = useState(0);
  const navigate = useNavigate();
  useEffect(() => {
    const interval = setInterval(() => {
      setCount((currentCount) => --currentCount);
    }, );

    count === 0 && navigate("/");
    return () => clearInterval(interval);
  }, [count, navigate]);
  return null
};

export default LoadingToRedirect;